import api from 'api';

export function postAllConfig(data) {
  return api.post('/app_config', data);
}

export function getFeatureSettings() {
  return api.get('/app_config/feature_settings');
}
